"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInvalidUrlResponse = instanceOfInvalidUrlResponse;
exports.InvalidUrlResponseFromJSON = InvalidUrlResponseFromJSON;
exports.InvalidUrlResponseFromJSONTyped = InvalidUrlResponseFromJSONTyped;
exports.InvalidUrlResponseToJSON = InvalidUrlResponseToJSON;
exports.InvalidUrlResponseToJSONTyped = InvalidUrlResponseToJSONTyped;
/**
 * Check if a given object implements the InvalidUrlResponse interface.
 */
function instanceOfInvalidUrlResponse(value) {
    if (!('detail' in value) || value['detail'] === undefined)
        return false;
    return true;
}
function InvalidUrlResponseFromJSON(json) {
    return InvalidUrlResponseFromJSONTyped(json, false);
}
function InvalidUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'detail': json['detail'],
    };
}
function InvalidUrlResponseToJSON(json) {
    return InvalidUrlResponseToJSONTyped(json, false);
}
function InvalidUrlResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'detail': value['detail'],
    };
}
//# sourceMappingURL=invalidUrlResponse.js.map